module.exports = __webpack_public_path__ + "2ba81a95ae7bbc2ef182ba0fddd2721e.svg";